

function removePositionAndDescription(obj) {
    if (Array.isArray(obj)) {
        return obj.map(removePositionAndDescription);
    } else if (obj && typeof obj === 'object') {
        const newObj = {};
        for (const key in obj) {
            if (key === 'position' || key === 'description') continue;
            newObj[key] = removePositionAndDescription(obj[key]);
        }
        return newObj;
    }
    return obj;
}

function sortObjectAndArrays(obj) {
  if (obj === null || typeof obj !== 'object') return obj;
  
  // ถ้าเป็น Array ให้ทำการเรียงลำดับสมาชิกข้างในด้วย (และครอบคลุมกรณี nested object ใน array)
  if (Array.isArray(obj)) {
    return obj.map(sortObjectAndArrays).sort((a, b) => {
      // จัดเรียงอย่างง่ายแปลงเป็น string เปรียบเทียบ (สำหรับ primitive และ object)
      const strA = typeof a === 'object' ? JSON.stringify(a) : String(a);
      const strB = typeof b === 'object' ? JSON.stringify(b) : String(b);
      return strA.localeCompare(strB);
    });
  }
  
  // ถ้าเป็น Object ให้เรียงคีย์ตามปกติ
  return Object.keys(obj).sort().reduce((sorted, key) => {
    sorted[key] = sortObjectAndArrays(obj[key]);
    return sorted;
  }, {});
}

export async function hashDiagram(diagram) {
    const sortObjectDidgram = sortObjectAndArrays(diagram);
    const cleanedDiagram = removePositionAndDescription(sortObjectDidgram);
    // console.log("cleanedDiagram:", JSON.stringify(cleanedDiagram))
    const encoder = new TextEncoder();
    const data = encoder.encode(JSON.stringify(cleanedDiagram));
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    // Convert buffer to hex string
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}

export async function upsertPolicy(policy) {
    return
}

export async function undeployPolicy(params) {
    return
}

export async function removePolicy(params) {
    return
}